import {
  snakeToCamel,
  snakeToCamelTemplateLiterals,
} from '@/common/converter/utils/snake-to-camel'
import { replacePlaceholder } from '@/common/converter/utils/replace-placeholder'
import { convertTitleList } from '@/common/converter/convert-title-list'

/**
 * source object (home) 와 target object (catalog) 을 받아
 * target object 에 source object 를 참조하여 cell property 생성
 * 구 celltop_list 형태를 반환
 * @param source
 * @param target
 * @returns {{blurtarget_img: string, cta: string, bgcolor: string, pagecount: string, count: string, title_list: unknown[]}}
 */
export const convertCellTopList = (source = {}, target = {}) => {
  const { contextProperty } = source
  const topContext = contextProperty?.top

  const cta = snakeToCamel(topContext?.cta)
  const titleList = topContext?.titleList.map(snakeToCamelTemplateLiterals)
  const blurTargetImg = snakeToCamel(topContext?.blurTargetImg)

  return {
    bgcolor: '',
    pagecount: '',
    count: '',
    blurtarget_img: replacePlaceholder(blurTargetImg, target) ?? '',
    cta: replacePlaceholder(cta, target),
    title_list: titleList.map(
      (title) => convertTitleList(replacePlaceholder(title, target)) ?? [],
    ),
  }
}
